export default {
  methods: {
    async submitWork(model, formData) {
      await this.$store.$createModel(model, formData, {
        useFormData: true,
      });
      this.$store.schoolSelectData = {}; // Reset school select data
      this.$toast("作品已提交成功");

      setTimeout(() => {
        this.$router.push({
          name: `${model}.list`,
        });
      }, 1000);
    },
    async setModelDataFn({ model, detailData }) {
      const exists = await this.$store.$getModel(
        model,
        { title: detailData.title },
        { apiAction: "exists" }
      );

      const formData = Object.assign({}, detailData, {
        provinceId: this.$store.schoolSelectData.provinceId,
        cityId: this.$store.schoolSelectData.cityId,
      });

      if (exists) {
        this.$confirm({
          title: "提示",
          message: "与该作品名称同名的作品已上传，是否替换之前上传的作品信息？",
          acceptText: "确认替换并提交",
          cancelText: "取消",
        }).then((result) => {
          result && this.submitWork(model, formData);
        });
      } else {
        this.submitWork(model, formData);
      }
    },
  },
};
